export const styles = {
    sectionTitle: (theme) => ({
        mb: 1,
        color: theme.palette.text.secondary,
        fontWeight: 600
    }),
    inputBorder: { borderRadius: 2 },
    formControl: { width: '100%' }
};
